<template>
  <div class="account-status">
    <div class="status-inner">
      <img class="image" src="/assets/images/delete-warning.svg" width="112" height="112" alt=""/>
      <h2 class="title">{{ $t('accountStatus.onHoldTitle') }}</h2>
      <p class="description">{{ $t('accountStatus.onHoldDescription') }}</p>
      <base-button variant="primary" class="status-button" @click="sendEmailToSupport" :disabled="dataLoading">{{ $t('accountStatus.onHoldButton') }}</base-button>
    </div>
  </div>
</template>

<script>
import errorMessageHandler from '@/mixins/errorMessageHandler'

export default {
  name: 'account-status-on-hold',
  data () {
    return {
      dataLoading: false
    }
  },
  props: {
    resourcesData: {
      type: Object,
      default: () => {
        return {}
      },
      required: true
    }
  },
  mixins: [errorMessageHandler],
  methods: {
    sendEmailToSupport () {
      this.dataLoading = true
      let id
      if (this.$props.resourcesData.subscriptionInfo) {
        id = this.$props.resourcesData.subscriptionInfo.subscriberIdentity
      } else if (this.$props.resourcesData.subscriberIdentity) {
        id = this.$props.resourcesData.subscriberIdentity
      } else {
        id = null
      }

      if (!id) {
        this.handleErrorMessage({})
        this.dataLoading = false
        return
      }
      this.$apiRequest.post('user/support/idleactivate?subscriberIdentity=' + id)
        .then(() => {
          this.toast('success', {
            message: this.$t('accountStatus.idleReactivationMessage')
          })
        })
        .catch(e => {
          this.toast('success', {
            message: this.$t('accountStatus.idleReactivationMessage')
          })
          this.handleErrorMessage(e.response.data)
        })
        .finally(() => {
          this.dataLoading = false
        })
    }
  }
}
</script>

<style scoped lang="scss" src="./account-status.scss"></style>
